import { tooltipClasses } from '@mui/material/Tooltip';

export const tooltipOverride = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ ownerState, theme }) => {
        const defaultSpacing = ownerState.arrow
          ? theme.spacing(1)
          : theme.spacing(0.5);

        const tooltipSpacing = ownerState.spacing ?? defaultSpacing;

        return {
          lineHeight: '1.4em',
          backgroundColor: theme.palette.text.primary,
          '&.MuiTooltip-tooltipPlacementLeft, &.MuiTooltip-tooltipPlacementRight, &.MuiTooltip-tooltipPlacementTop, &.MuiTooltip-tooltipPlacementBottom': {
            margin: 4
          },
          // Unfortunately, MUI control the Tooltip's margin through deeply
          // nested selectors, and to override it we should use the same
          // selectors as them
          [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
            marginTop: tooltipSpacing
          },
          [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
            marginBottom: tooltipSpacing
          },
          [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
            marginLeft: tooltipSpacing
          },
          [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
            marginRight: tooltipSpacing
          }
        };
      }
    }
  }
};
